import React from "react";
import PropTypes from "prop-types";
import { Card, Layout, SkeletonBodyText, SkeletonDisplayText, TextContainer } from "@shopify/polaris";

const OnboardingStepSkeleton = ({ cardCount, primaryLines, showBanner }) => (
  <Layout>
    {showBanner && (
      <Layout.Section>
        <div style={{ marginBottom: "16px" }}>
          <Card sectioned>
            <SkeletonBodyText lines={2} />
          </Card>
        </div>
      </Layout.Section>
    )}
    <Layout.Section>
      {Array.from({ length: cardCount }, (_, index) => (
        <div key={index} style={index > 0 ? { marginTop: "20px" } : undefined}>
          <Card sectioned>
            <TextContainer>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={primaryLines} />
            </TextContainer>
          </Card>
        </div>
      ))}
    </Layout.Section>
  </Layout>
);

OnboardingStepSkeleton.propTypes = {
  cardCount: PropTypes.number,
  primaryLines: PropTypes.number,
  showBanner: PropTypes.bool,
};

OnboardingStepSkeleton.defaultProps = {
  cardCount: 1,
  primaryLines: 6,
  showBanner: false,
};

export default OnboardingStepSkeleton;
